// A product's value in its group, as the admin edits it: { key, label, hex,
// image, order }, where `label` is a string or { <language>: text }.

/** A text that may be per language (a product name, a label), as one string. */
export const textOf = (value, language = "en") => {
  if (typeof value === "string") return value
  if (!value || typeof value !== "object") return ""
  return value[language] || value.en || Object.values(value).find((text) => typeof text === "string" && text) || ""
}

/** The label with the text of one language replaced (a plain string becomes the English one). */
export const withLabel = (label, language, text) => {
  const map = typeof label === "string" ? (label ? { en: label } : {}) : { ...(label || {}) }
  if (text) map[language] = text
  else delete map[language]
  return map
}

/** A key from a label: "Dark blue" → "dark-blue". */
export const keyFromLabel = (text) =>
  String(text || "")
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9Ѐ-ӿ]+/g, "-")
    .replace(/^-+|-+$/g, "")

export const DISPLAYS = [
  { value: "image", name: "Picture" },
  { value: "color", name: "Color swatch" },
  { value: "label", name: "Label" },
]
